export default __webpack_public_path__ + "static/media/cloud_spanner.06011fde.svg";